import styled from '@emotion/styled';
import { LoadingOutlined } from '@ant-design/icons/lib/icons';
import { FC } from 'react';

const Wrapper = styled.div<{ fullScreen?: boolean }>(
  {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    minHeight: '10rem',
  },
  ({ fullScreen }) =>
    fullScreen && {
      minHeight: '100vh',
    }
);

export interface LoaderProps {
  className?: string;
  fullScreen?: boolean;
}

export const Loader: FC<LoaderProps> = ({ className, fullScreen }) => {
  return (
    <Wrapper className={className} fullScreen={fullScreen}>
      <LoadingOutlined style={{ fontSize: '2.5rem' }} />
    </Wrapper>
  );
};
